import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import LoadingSpinner from '../../../components/loading-spinner';

import {
    clear_vehicle,
    createVehicle,
    CREATE_VEHICLE,
    getAllVehicle,
} from "../../../redux/vehicles";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Input from "../../../components/input";

const Vehicle = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_vehicle = useSelector((state) => state.vehicle_module._get_all_vehicle);
    const _create_vehicle = useSelector((state) => state.vehicle_module._create_vehicle);
    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(getAllVehicle(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_vehicle && _get_all_vehicle.data && _get_all_vehicle.data.datos) {
            setData(_get_all_vehicle.data.datos);
        }
    }, [_get_all_vehicle]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        placa: "",
        marca: "",
        modelo: "",
        color: "",
        anio: "",
        kilometraje_actual: "",
        activo: true,
        imagen: "",
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'view_vehicles').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        history.push(`/vehiculo/editar/${item.id}`);
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleFileChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.files[0],
        });
    };

    useEffect(() => {
        if (_create_vehicle.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_vehicle(CREATE_VEHICLE));
            dispatch(getAllVehicle(token));
            let id_vehicle = _create_vehicle.data.id;
            history.push(`/vehiculo/editar/${id_vehicle}`);
            setIsLoading(false);
            setModal(false);
        } else if (_create_vehicle.status !== 0) {
            dispatch(clear_vehicle(CREATE_VEHICLE));
            toast.error(_create_vehicle.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_vehicle, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.placa === "") {
            toast.error("Debe ingresar la placa", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.marca === "") {
            toast.error("Debe ingresar la marca", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.modelo === "") {
            toast.error("Debe ingresar el modelo", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.color === "") {
            toast.error("Debe ingresar el color", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.anio === "") {
            toast.error("Debe ingresar el año", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (form.kilometraje_actual === "") {
            toast.error("Debe ingresar el kilometraje actual", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createVehicle(token, form));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Vehículos", link: "/vehiculos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_vehicles').length > 0 ?
                                        <Button type="button" text="Crear" theme="btn btn-success" onClick={() => {
                                            setModal(true);
                                            setForm({...form, placa: '', marca: '', modelo: '', color: '', anio: '', kilometraje_actual: '', imagen: ''});
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "placa",
                                                label: "Placa",
                                                type: "text",
                                            },
                                            {
                                                name: "marca",
                                                label: "Marca",
                                                type: "text",
                                            },
                                            {
                                                name: "modelo",
                                                label: "Modelo",
                                                type: "text",
                                            },
                                            {
                                                name: "empleados",
                                                label: "No. empleados",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Crear vehículo</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <Input
                                    name="placa"
                                    label="Placa"
                                    value={form.placa}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="marca"
                                    label="Marca"
                                    value={form.marca}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="modelo"
                                    label="Modelo"
                                    value={form.modelo}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="color"
                                    label="Color"
                                    value={form.color}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="anio"
                                    label="Año"
                                    value={form.anio}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="kilometraje_actual"
                                    label="Kilometraje actual"
                                    value={form.kilometraje_actual}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <Input
                                    name="imagen"
                                    label="Imagen"
                                    type="file"
                                    onChange={handleFileChange}
                                />
                            </div>
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Guardar" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Vehicle;
